export default "__VITE_ASSET__1kxEQ0WL__"